export const CLARIAH_LAPOSTA_NEWSLETTER_FORM_URL =
  "https://clariah.email-provider.nl/memberforms/subscribe/standalone/form/?a=4olzg7aznf&l=vsxq4akqhr";

export const DATE_INPUT_TYPE = "date";
export const EMAIL_INPUT_TYPE = "email";
export const MEDIA_INPUT_TYPE = "media";
export const SELECT_INPUT_TYPE = "select";
export const TEXT_INPUT_TYPE = "text";
export const TEXTAREA_INPUT_TYPE = "textarea";
export const URL_INPUT_TYPE = "url";

export const DOWN = "DOWN";
export const UP = "UP";

export const TINY = "tiny";
export const SMALL = "small";
export const MEDIUM = "medium";
export const LARGE = "large";

export const VIMEO = "vimeo";
export const YOUTUBE = "youtube";
export const MUX = "mux";

export const TYPE_LINK = "link";
export const TYPE_BUTTON = "button";

export const DATE_AND_TIME_TYPE = "dateAndTime";
export const EMAIL_TYPE = "email";
export const LOCATION_TYPE = "location";
export const PHONE_TYPE = "phone";
export const WEBSITE_TYPE = "website";

export const TYPE_RICHTEXT_SIMPLE = "richtext-simple";
export const TYPE_RICHTEXT_SANS = "richtext-sans";

export const NL = "nl";
export const EN = "en";

export const PAGE_TYPE = "page"; // this type doesn't actually exist gets prefixed in sitelink with clariah. and ineo.

export const PERSON_TYPE = "clariah.person";
export const PROJECT_TYPE = "project";
export const SEARCH_TYPE = "search";

export const DISCIPLINE_TYPE = "discipline";
export const PROJECT_CATEGORY_TYPE = "projectCategory";
export const RESEARCH_DOMAIN_TYPE = "researchDomainType";
export const RESEARCH_TYPE_TYPE = "researchType";
export const RESOURCE_TYPE_TYPE = "resourceType";
export const SPECIALISM_TYPE = "specialism";
